import { render, staticRenderFns } from "./ItemSubGroup.vue?vue&type=template&id=2480ce34&scoped=true&"
import script from "./ItemSubGroup.vue?vue&type=script&lang=js&"
export * from "./ItemSubGroup.vue?vue&type=script&lang=js&"
import style0 from "./ItemSubGroup.vue?vue&type=style&index=0&id=2480ce34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480ce34",
  null
  
)

export default component.exports